import { useSyncExternalStore } from 'react'

import type {
  GuestDraftSnapshot,
  GuestDraftStore,
} from '~publish/helpers/guestDrafts'

export function useGuestDrafts(store: GuestDraftStore): GuestDraftSnapshot {
  return useSyncExternalStore(
    store.subscribe,
    store.getSnapshot,
    store.getSnapshot,
  )
}
